import { jsx as _jsx } from "react/jsx-runtime";
import { AssessmentPositiveNegativeKinds } from 'constants/assessments';
import { AssessmentPositiveNegative } from './assessmentPositiveNegative';
import { AssessmentRiskScore } from './assessmentRiskScore';
export var AssessmentScore = function (_a) {
    var questionnaire = _a.questionnaire;
    var resultsSanitized = questionnaire.results_sanitized, kind = questionnaire.kind;
    var maxScore = questionnaire.information.max_score;
    // In staging, rarely a questionnaire that should have scores is missing it. Not sure if can happen in prod, but handle just in case..
    if (AssessmentPositiveNegativeKinds.includes(kind) ||
        !('score' in questionnaire.results_sanitized)) {
        return (_jsx(AssessmentPositiveNegative, { kind: kind, positive: resultsSanitized.positive }));
    }
    return (_jsx(AssessmentRiskScore, { risk: resultsSanitized.risk, score: resultsSanitized.score, maxScore: maxScore }));
};
